import { Component, Input, OnDestroy } from '@angular/core';
import { ModalService, SimpleMessageService, Tenant, WebAppCommonModule } from '@allbesmart/web-app-common';
import { Subscription } from 'rxjs';
import { RanConfigurationService } from "../../services/ran-configuration.service";


@Component({
    selector: 'oaibox-reset-ran-configuration-warning-modal',
    templateUrl: './reset-ran-configuration-warning-modal.component.html',
    styleUrls: ['./reset-ran-configuration-warning-modal.component.css'],
    imports: [WebAppCommonModule]
})
export class ResetRanConfigurationWarningModalComponent implements OnDestroy {

  @Input() public tenant?: Tenant;

  private deleteGnbCustomConfigurationSubscription?: Subscription;

  constructor(
    private modalService: ModalService,
    private ranConfigurationService: RanConfigurationService,
    private simpleMessageService: SimpleMessageService
  ) {
  }

  protected resetRanConfiguration(): void {
    if (this.tenant) this.deleteGnbCustomConfigurationSubscription = this.ranConfigurationService.deleteCustomRanConfiguration(this.tenant.id)
        .subscribe({
          next: () => this.onConfigurationReset(),
          error: error => {
            if (error.status === 404) {
              // 404 means that custom configuration doesn't exist, so it was already reset, we can move along
              this.onConfigurationReset();
              return;
            }
            this.simpleMessageService.showSimpleMessage({
              message: "Configuration not reset!", icon: "fa-solid fa-triangle-exclamation", color: "danger"
            });
            this.modalService.popModal();
          }
        });
  }

  private onConfigurationReset(): void {
    this.simpleMessageService.showSimpleMessage({
      message: "Configuration reset successfully!", icon: "fa-solid fa-check-double", color: "success"
    });
    this.modalService.popModal();
  }

  protected cancel(): void {
    this.modalService.popModal();
  }

  ngOnDestroy(): void {
    this.deleteGnbCustomConfigurationSubscription?.unsubscribe();
  }
}
